// Mapping of ?topic= query param values to friendly inquiry-type labels shown
// in emails routed to office@balministries.org and used to pre-fill the
// Contact form subject line.
export const INQUIRY_TOPICS = {
  "ask-chaplain": "Ask Chaplain Derrick",
  "book-derrick": "Book Derrick Hall for Speaking",
  "workshop-request": "Request a Workshop",
  "bulk-orders": "Bulk Orders & Organizational Training",
  "licensing": "Licensing Opportunities",
  "general": "General Inquiry",
};

export const resolveInquiry = (topicParam) => {
  if (!topicParam) return { key: "general", label: INQUIRY_TOPICS.general };
  const key = topicParam.trim().toLowerCase();
  return {
    key,
    label: INQUIRY_TOPICS[key] || INQUIRY_TOPICS.general,
  };
};
